/**
 * subjectNames.js — Display-name map for internal subject slugs.
 * Use getSubjectDisplayName() wherever a slug might appear in user-facing text.
 */

export const SUBJECT_DISPLAY_NAMES = {
  // Core subjects
  mathematics:            'Mathematics',
  mathematics_advanced:   'Mathematics Advanced',
  mathematics_extension:  'Mathematics Extension',
  mathematical_methods:   'Mathematical Methods',
  specialist_mathematics: 'Specialist Mathematics',
  english:                'English',
  english_advanced:       'English Advanced',
  english_standard:       'English Standard',
  english_extension:      'English Extension',
  science:                'Science',
  history:                'History',
  geography:              'Geography',
  biology:                'Biology',
  chemistry:              'Chemistry',
  physics:                'Physics',
  economics:              'Economics',
  legal_studies:          'Legal Studies',
  business_studies:       'Business Studies',
  business_management:    'Business Management',
  psychology:             'Psychology',
  pdhpe:                  'PDHPE',
  drama:                  'Drama',
  music:                  'Music',
  visual_arts:            'Visual Arts',
  study_skills:           'Study Skills',
  thinking_skills:        'Thinking Skills',
  // Exam subjects
  reading:    'Reading',
  writing:    'Writing',
  language:   'Language Conventions',
  numeracy:   'Numeracy',
  thinking:   'Thinking Skills',
  digital:    'Digital Technologies',
  spelling:   'Spelling',
  // Internal slug aliases
  maths:      'Mathematics',
  maths_adv:  'Mathematics Advanced',
  english_adv:'English Advanced',
  maths_methods: 'Mathematical Methods',
  business_mgmt: 'Business Management',
  hass:       'HASS',
  legal:      'Legal Studies',
  business:   'Business Studies',
};

/**
 * Convert any subject slug to a human-readable display name.
 * Falls back to title-casing the slug if no mapping found.
 */
export function getSubjectDisplayName(slug) {
  if (!slug) return '';
  if (SUBJECT_DISPLAY_NAMES[slug]) return SUBJECT_DISPLAY_NAMES[slug];
  // Fallback: replace underscores with spaces, title-case
  return slug.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
